import {CUSTOM_SCROLL, scrollSetting} from "./globalVars";
import {CustomEventHandler} from "../utils/CustomEventHandler";
import {MathUtil} from "../utils/MathUtil";

export default class SectionTitle {
    constructor(container) {
        this.container = container;
        // if (!this.container) this.container = document;
        this.init();
    }

    init () {
        this.el = this.container.getElementsByClassName('section-title')[0];
        this.footerEl = this.container.querySelector('footer');
        // console.log(this.container);

        if (!this.el) return false;
        this.rightEl = this.el.querySelector('content');
        this.addEvent();
    }

    addEvent() {
        CustomEventHandler.addHandler(window,CUSTOM_SCROLL, (e)=>this.onScrollHandler(e));

        if (!scrollSetting.smooth) {
            this.el.style.position = 'fixed';
        }
    }

    onScrollHandler(e) {
        // console.log(e.detail);
        let velocity = e.detail;
        let opacity;
        let footerTop = (this.footerEl.getBoundingClientRect().top - window.innerHeight) * -1; //+ parseFloat(window.getComputedStyle(this.footerEl).paddingTop);
        let titleTop = parseFloat(window.getComputedStyle(this.el).top);
        let titleHeight = parseFloat(window.getComputedStyle(this.el).height);

        let footerPadding = ( window.innerHeight-(titleTop + titleHeight + footerTop)) ;

        if (footerPadding > 0) {
            footerPadding = 0;
        }


        velocity = velocity + footerPadding;
        opacity =  MathUtil.clamp( (400 - velocity)/400, 0, 0.9) + 0.05;

        if (scrollSetting.smooth) {
            this.el.style.transform = 'translate3d(0, ' + velocity + 'px, 0)';
        }
        this.rightEl.style.opacity = opacity;

    }

    setShow() {
        if (this.el) {
            this.el.classList.add('onTrans');
        }

        let titleEls;
        titleEls = this.container.getElementsByClassName('component-title-holder');

        if (titleEls.length === 0) return;

        for (let i=0;i<i.length;i++) {
            titleEls[i].classList.add('onTrans');
        }
        // titleEls.forEach((tmpEl)=>{
        // tmpEl.classList.add('onTrans');
        // })
    }
}
